import React from 'react';
import { Icon } from '@chargify/icons';

import Heading from '../../../Heading';

import { Container, Close } from './Title.styles';

type TitleProps = {
  /**
   * Close event handler
   */
  onClose: () => void;
  /**
   * Modal title content
   */
  title: string;
};

const Title = ({ title, onClose }: TitleProps) => (
  <Container>
    <Heading variant="h3">{title}</Heading>
    <Close onClick={onClose} tabIndex={0}>
      <Icon type="close" size={16} fill="gray.light" />
    </Close>
  </Container>
);

export default Title;
